import { useQuery } from 'react-query';

import { httpService } from '../../services/http.service';
import { BASE_URL, USER } from '../../constants/endpoints';

const { CONTROLLERS: { APP_CENTER: { VERSION, BASE } } } = USER;

export const useAppCenter = () => useQuery(
  'appCenterData',
  async () => {
    const { data } = await httpService.get((`${BASE_URL}/api/${VERSION}/${BASE}`));
    return data;
  },
  {
    enabled: false,
  },
);
